// extracted by mini-css-extract-plugin
module.exports = {"fei2bp7":"fei2bp7","forgot-password-btn":"forgot-password-btn","login-btn":"login-btn"};